<script>
import { IconChevronDown } from "@/components/icons/index";
import { BButton } from "bootstrap-vue";

/**
 * TODO: Validation of file type on drop
 */
export default {
  name: 'AppFileUpload',

  components: {
    IconChevronDown,
    BButton,
  },

  props: {
    file: { type: [String, File], default: "" },
    disabled: { type: Boolean, default: false },
    fileFormat: { type: String, default: '.xlsx, .xls, .csv' },
  },

  data() {
    return {
      fileData: "",
      fileName: "",
    };
  },

  watch: {
    file(val) {
      this.fileData = val;
    },
  },

  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      // if (!files[0].type.includes('image'))
      //   return
      this.createFile(files[0]);
      this.fileName = files[0].name;
      // Reset input value to trigger to fix same file upload
      this.$refs.input.value = '';
    },
    createFile(file) {
      var reader = new FileReader();
      reader.onloadend = (e) => {
        this.removeFile();
        this.fileData = e.target.result;
      };
      reader.readAsDataURL(file);
      this.$emit("upload", file);
    },
    removeFile() {
      this.fileData = "";
      this.fileName = "";
    },
    deleteFile() {
      this.removeFile();
      this.$emit("upload", null);
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return "0 Bytes";

      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    },
  },
};
</script>

<template>
  <div>
    <!-- Upload Box -->
    <div
      class="upload-box"
      @drop.prevent="onFileChange"
      @dragenter.prevent
      @dragover.prevent
      @click="$refs.input.click()"
      :class="{
        'pe-none opacity-75': disabled,
      }"
    >
      <input
        ref="input"
        type="file"
        :accept="fileFormat"
        class="d-none"
        @change="onFileChange"
      />
      <div class="text-center">
        <!-- <IconChevronDown /> -->
        <img
          src="/assets/images/icons/upload.png"
          alt="upload icon"
          width="68px"
          height="68px"
        />
        <p class="mt-3 mb-0 font-size-14 fw-medium" :style="{ color: '#74788D' }">
          Drop files here or click to upload.
        </p>
      </div>
    </div>

    <!-- File Box -->
    <div v-if="fileData" class="file-box mt-2">
      <div class="d-flex align-items-center py-2 px-3">
        <div class="flex-shrink-0 me-3">
          <div>
            <img
              src="/assets/images/icons/csv.png"
              alt="csv-file-icon"
              width="39px"
              height="37px"
              class="img-fluid rounded d-block"
            />
          </div>
        </div>
        <div class="flex-grow-1">
          <div>
            <p class="font-size-14 mb-0" :style="{ color: '#707070' }">{{ file.name }}</p>
            <p class="font-size-12 mb-0" :style="{ color: '#707070' }">
              {{ formatBytes(file.size) }}
            </p>
          </div>
        </div>
        <div class="flex-shrink-0 ms-3">
          <b-button
            variant="primary"
            class="button-remove"
            @click.stop="deleteFile()"
            :disabled="disabled"
          >
            Delete
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upload-box {
  min-height: 160px;
  width: 100%;
  padding: 30px;
  border: 2px dashed #ced4da;
  background: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  .image {
    &-container {
      .button-remove {
        display: none;
      }
      &:hover {
        .image-overlay {
          display: block;
          background: rgba(0, 0, 0, 0.3);
        }
        .button-remove {
          display: block;
        }
      }
    }
    &-overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0);
      transition: background 0.5s ease;
    }
  }
}

.file-box {
  border: 1px solid #cfd0d7;
  border-radius: 6px;
}
</style>

